import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SkeletonSportsBaseComponent } from '../skeleton-ui/skeleton-sports-base.component';
import { SkeletonBetslipComponent } from './skeleton-betslip.component';
import { SkeletonEventsComponent } from './skeleton-events.component';
import { SkeletonGridComponent } from './skeleton-grid.component';
import { SkeletonLivepageComponent } from './skeleton-livepage.component';
import { SkeletonMainDestopComponent } from './skeleton-main-desktop.component';
import { SkeletonMainMobileComponent } from './skeleton-main-mobile.component';
import { SkeletonMarqueeComponent } from './skeleton-marquee.component';
import { SkeletonMinigamesComponent } from './skeleton-minigames.component';
import { SkeletonTopsportsComponent } from './skeleton-topsports.component';

@NgModule({
    declarations: [
        SkeletonMarqueeComponent,
        SkeletonBetslipComponent,
        SkeletonEventsComponent,
        SkeletonMinigamesComponent,
        SkeletonEventsComponent,
        SkeletonTopsportsComponent,
        SkeletonGridComponent,
        SkeletonMainDestopComponent,
        SkeletonMainMobileComponent,
        SkeletonLivepageComponent,
        SkeletonSportsBaseComponent,
    ],
    exports: [SkeletonSportsBaseComponent, SkeletonMainDestopComponent, SkeletonMainMobileComponent, SkeletonLivepageComponent],
    imports: [CommonModule],
})
export class SkeletonModule {}
